import { deleteCookie, setCookie } from 'cookies-next/client';

import {
  COMBINED_FLOW_LAYOUT,
  COMBINED_FLOW_LAYOUT_ONE_HOUR_EXPIRY,
} from '@/constants/cookies';
import { isServerCheck } from '@/modules/env/isServerCheck';

const COOKIE_CONFIG = {
  path: '/',
  maxAge: COMBINED_FLOW_LAYOUT_ONE_HOUR_EXPIRY,
  secure: true,
};

export const COMBINED_FLOW_COOKIE_VALUE = '1';

export async function setCombinedFlowCookie() {
  if (isServerCheck()) {
    const { cookies } = await import('next/headers');
    (await cookies()).set(
      COMBINED_FLOW_LAYOUT,
      COMBINED_FLOW_COOKIE_VALUE,
      COOKIE_CONFIG
    );
    return;
  }

  setCookie(COMBINED_FLOW_LAYOUT, COMBINED_FLOW_COOKIE_VALUE, COOKIE_CONFIG);
}

export async function removeCombinedFlowCookie() {
  if (isServerCheck()) {
    const { cookies } = await import('next/headers');
    (await cookies()).delete({
      name: COMBINED_FLOW_LAYOUT,
      path: '/',
      secure: true,
    });
  }
  deleteCookie(COMBINED_FLOW_LAYOUT, COOKIE_CONFIG);
}
